import { render, staticRenderFns } from "./MantenedorTelcoPantalla.vue?vue&type=template&id=6f562a24&"
import script from "./MantenedorTelcoPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTelcoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f562a24', component.options)
    } else {
      api.reload('6f562a24', component.options)
    }
    module.hot.accept("./MantenedorTelcoPantalla.vue?vue&type=template&id=6f562a24&", function () {
      api.rerender('6f562a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTelco/MantenedorTelcoPantalla.vue"
export default component.exports